module.exports = __webpack_public_path__ + "img/solution-tool-system-pic-3.34a13b27.png";